import { ref } from 'vue'
import { useAdminDB } from '@/composables/useAdminDB'

// Estado de módulo (singleton), mesmo espírito de useBlacklist.ts — mas,
// diferente daquele, NÃO carrega sozinho no import. conversationActionsService.ts
// importa este arquivo pra checar isLabelProtected() no enforcement de
// setConversationLabels(), e tem teste unitário que não espera nenhum fetch
// extra por trás de um simples import — leitura 100% síncrona/passiva evita
// esse acoplamento. Quem precisa do dado fresco chama loadProtectedLabels()
// explicitamente (main.ts no bootstrap, LabelsView.vue no mount).
const protectedTitles = ref<Set<string>>(new Set())

export async function loadProtectedLabels(): Promise<void> {
  try {
    const rows = await useAdminDB().loadProtectedLabels()
    protectedTitles.value = new Set(rows)
  } catch { /* mantém o cache atual em caso de falha */ }
}

/** Leitura pura do cache atual — vazio até loadProtectedLabels() resolver pela primeira vez. */
export function getProtectedLabelTitles(): Set<string> {
  return protectedTitles.value
}

export function isLabelProtected(title: string): boolean {
  return protectedTitles.value.has(title)
}

/** Usado pela tela Etiquetas ao marcar/desmarcar proteção — persiste e já atualiza o cache local. */
export async function setLabelProtected(title: string, isProtected: boolean): Promise<void> {
  const db = useAdminDB()
  if (isProtected) await db.protectLabel(title)
  else await db.unprotectLabel(title)

  const next = new Set(protectedTitles.value)
  if (isProtected) next.add(title)
  else next.delete(title)
  protectedTitles.value = next
}
